import type { VariablesOf } from "@graphql-typed-document-node/core";
import { safe } from "pb.safe";

import { $, mutation } from "../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../shared/shared/api-client";

export function removeDeviceFromEntity({
	apiClient,
	...variables
}: {
	apiClient: ApiClient;
} & VariablesOf<typeof removeDeviceFromEntity.gql.removeDeviceFromEntity>) {
	return safe(() =>
		apiClient.request(
			removeDeviceFromEntity.gql.removeDeviceFromEntity,
			variables,
		),
	);
}

removeDeviceFromEntity.gql = {
	removeDeviceFromEntity: mutation("removeDeviceFromEntity", (q) => [
		q.removeDeviceFromEntity({
			deviceUuid: $("deviceUuid"),
			entityUuid: $("entityUuid"),
		}),
	]),
};
